import React, { useState, useEffect, useRef } from "react";
import AOS from "aos";
import "aos/dist/aos.css";

import { Container, Row, Col } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

import Header from "../components/Header";
import Footer from "../components/Footer";
import { useTranslation } from "../contexts/TranslationContext";

import { useLocation } from "react-router-dom";
import { scroller } from "react-scroll";

import homeServices from "../assets/images/home-service.png";
import cleaning from "../assets/images/cleaning.png";
import repair from "../assets/images/repair.png";
import construction from "../assets/images/construction.png";
import carService from "../assets/images/car-service.png";
import businessService from "../assets/images/business-service.png";
import petService from "../assets/images/pet-service.png";
import lifestyle from "../assets/images/lifestyle.png";

import screenshot1 from "../assets/images/ss1.png";
import screenshot2 from "../assets/images/ss2.png";
import screenshot3 from "../assets/images/ss3.png";
import screenshot4 from "../assets/images/ss4.png";
import screenshot5 from "../assets/images/ss5.png";

import bannerBrush from "../assets/images/banner-brush.png";
import companyBrush from "../assets/images/company-brush.png";
import servicesBrush from "../assets/images/services-brush.png";
import screenshotBrush from "../assets/images/screenshots-brush.png";
import downloadBrush from "../assets/images/download-brush.png";

import create from "../assets/images/create-request.png";
import discount from "../assets/images/discount.png";
import gallery from "../assets/images/gallery.png";

import downloadImg from "../assets/images/downloadSection.png";

import appleBtn from "../assets/images/appleBtn.png";
import googleBtn from "../assets/images/googleBtn.png";

import bannerLeftImg from "../assets/images/banner-phone-left.png";
import bannerSSr from "../assets/images/banner-ss-r.png";

import companyWorker from "../assets/images/company-worker.png";

const HomePage = () => {
  const navigate = useNavigate();
  const [scrollX, setScrollX] = useState(0);
  const [currentScreenshot, setCurrentScreenshot] = useState(0);
  const { t, isRTL } = useTranslation();

  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY;
      const moveX = scrollPosition * 0.5;
      setScrollX(moveX);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const svgRef = useRef(null);
  const pathRef = useRef(null);

  useEffect(() => {
    const svg = svgRef.current;
    const path = pathRef.current;

    if (!svg || !path) return;

    const scroll = () => {
      const distance = window.scrollY;
      const totalDistance = svg.clientHeight - window.innerHeight;
      console.log(totalDistance);
      const percentage = distance / totalDistance;
      const pathLength = path.getTotalLength();

      path.style.strokeDasharray = `${pathLength}`;
      path.style.strokeDashoffset = `${pathLength * (1 - percentage)}`;
    };

    scroll();
    window.addEventListener("scroll", scroll);

    return () => {
      window.removeEventListener("scroll", scroll);
    };
  }, []);

  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const section = location.hash.replace("#", "");
      scroller.scrollTo(section, {
        duration: 500,
        delay: 0,
        smooth: "easeInOutQuart",
      });
    }
  }, [location]);

  // Initialize AOS
  useEffect(() => {
    AOS.init({
      duration: 1000,
      easing: "ease-in-out",
      once: true,
      offset: 100,
    });
  }, []);

  const features = [
    {
      title: "1. Search",
      text: "Explore professionals by category, location, or expertise.",
      img: create,
      gradient: "black-gradient",
    },
    {
      title: "2. Book",
      text: "Schedule your service instantly with flexible time slots.",
      img: discount,
      gradient: "black-gradient",
    },
    {
      title: "3. Connect",
      text: "Chat, call, or video consult within the platform.",
      img: gallery,
      gradient: "black-gradient",
    },
    {
      title: "4. Get It Done",
      text: "Enjoy hassle-free, reliable service anytime, anywhere.",
      img: gallery,
      gradient: "black-gradient",
    },
  ];

  const screenshots = [
    { id: 1, image: screenshot1 },
    { id: 2, image: screenshot2 },
    { id: 3, image: screenshot3 },
    { id: 4, image: screenshot4 },
    { id: 5, image: screenshot5 },
  ];

  useEffect(() => {
    if (location.hash) {
      const section = location.hash.replace("#", "");
      scroller.scrollTo(section, {
        duration: 500,
        delay: 0,
        smooth: "easeInOutQuart",
      });
    }
  }, [location]);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentScreenshot((prevIndex) =>
        prevIndex === screenshots.length - 1 ? 0 : prevIndex + 1
      );
    }, 3000);

    return () => clearInterval(interval);
  }, [screenshots.length]);

  return (
    <>
      <Header />
      {/* Banner Sec */}
      <section className="header-banner" id="home" dir={isRTL ? 'rtl' : 'ltr'}>
        <div className="container-fluid">
          <div className="row">
           
            
            {/* Content - Desktop: center, Mobile: below images */}
            <div className="col-md-6 col-12 offset-md-3 order-3 order-md-2">
              <div
                className="header-txt1"
                data-aos="fade-up"
                data-aos-delay="400"
              >
                <h1>
                  {t("banner.title1")}
                  <img
                      src={bannerBrush}
                      alt=""
                      className="handyman-img"
                      data-aos="zoom-in"
                      data-aos-delay="800"
                    />
                  <span className="handyman-wrapper">
                    <span className="handyman-txt"> {t("banner.handyman")}</span>
                  </span>
                </h1>

                <p data-aos="fade-up" data-aos-delay="800">
                  {t("banner.description")}
                </p>
              </div>
              <div
                className="banner-btns d-flex justify-content-center align-items-center gap-3"
                data-aos="fade-up"
                data-aos-delay="1000"
              >
               
                <button
                  type="submit"
                  className="btn fw-bold py-2 shadow services-btn rounded-pill text-white mb-4"
                  data-aos="zoom-in"
                  data-aos-delay="1400"
                >
                  Get Started Now
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* About */}
      <section className="container mt-5 text-center" id="about" dir={isRTL ? 'rtl' : 'ltr'}>
        <div className="company-heading" data-aos="fade-up">
          <h1 data-aos="fade-up" data-aos-delay="200">
            <img
              src={bannerBrush}
              alt=""
              className="company-brush"
              data-aos="zoom-in"
              data-aos-delay="400"
            />
            {t("about.title")} <span className="company-txt">{t("about.companyName")} </span>
          </h1>
        </div>
        <div className="row my-5">
          <div class="col-md-6 col-sm-12">
            <div
              className="company-worker"
              data-aos="fade-right"
              data-aos-delay="200"
            >
              <img src={companyWorker} className="w-100 rounded-5" alt="" />
            </div>
          </div>
          <div class="col-md-6 col-sm-12">
            <p
              className="mt-5 company-para text-start"
              data-aos="fade-up"
              data-aos-delay="600"
            >
              Royal Spark is an all-in-one on-demand platform designed to connect users with verified professionals across a variety of services and industries. Whether you need a plumber, personal trainer, lawyer, tutor, or beauty expert — we bring them all to your fingertips.
              <br /> <br />
              With just a few taps, you can browse, book, and manage services seamlessly, saving you time and giving you peace of mind.
            </p>
          </div>
        </div>
      </section>

      {/* Our Best Service */}
      <section
        className="container-fluid text-center mb-5 top pt-5 services-section"
        id="services"
        dir={isRTL ? 'rtl' : 'ltr'}
      >
        <div className="services-heading" data-aos="fade-up">
          <h1 data-aos="fade-up" data-aos-delay="200">
            <span className="services-txt">{t("services.title")}</span> {t("services.subtitle")}
          </h1>
          <img
            src={bannerBrush}
            alt=""
            className="company-brush services-brush"
            data-aos="zoom-in"
            data-aos-delay="400"
          />
          <p
            className="mt-5 company-para"
            data-aos="fade-up"
            data-aos-delay="600"
          >
            {t("services.description")}
          </p>
        </div>
        <div className="container py-5">
          <div className="row services-row row-cols-1 row-cols-sm-2 row-cols-md-3 row-cols-lg-4 g-4 ">
            <div
              className="col rounded-4 service1"
              data-aos="fade-up"
              data-aos-delay="200"
            >
              <div className="service-icon">
                <i className="bi bi-house-door-fill"></i>
              </div>
              <div>
                <h4>Home Services</h4>
                <p>
                  Cleaning, repairs, plumbing, electrical, painting
                </p>
              </div>
            </div>
            <div
              className="col rounded-4 service1"
              data-aos="fade-up"
              data-aos-delay="400"
            >
              <div className="service-icon">
                <i className="bi bi-laptop"></i>
              </div>
              <div>
                <h4>Business & IT</h4>
                <p>
                  Consultants, developers, designers, marketing experts
                </p>
              </div>
            </div>
            <div
              className="col rounded-4 service1"
              data-aos="fade-up"
              data-aos-delay="600"
            >
              <div className="service-icon">
                <i className="bi bi-heart-pulse-fill"></i>
              </div>
              <div>
                <h4>Health & Wellness</h4>
                <p>
                  Personal trainers, therapists, nutritionists
                </p>
              </div>
            </div>
            <div
              className="col rounded-4 service1"
              data-aos="fade-up"
              data-aos-delay="800"
            >
              <div className="service-icon">
                <i className="bi bi-scissors"></i>
              </div>
              <div>
                <h4>Beauty & Lifestyle</h4>
                <p>
                  Stylists, makeup artists, personal care experts
                </p>
              </div>
            </div>
            <div
              className="col rounded-4 service1"
              data-aos="fade-up"
              data-aos-delay="1000"
            >
              <div className="service-icon">
                <i className="bi bi-book-fill"></i>
              </div>
              <div>
                <h4>Education & Coaching</h4>
                <p>
                  Tutors, language instructors, career coaches
                </p>
              </div>
            </div>
            <div
              className="col rounded-4 service1"
              data-aos="fade-up"
              data-aos-delay="1200"
            >
              <div className="service-icon">
                <i className="bi bi-briefcase-fill"></i>
              </div>
              <div>
                <h4>Legal & Professional</h4>
                <p>
                  Lawyers, advisors, tax consultants
                </p>
              </div>
            </div>
           
          </div>
        </div>
      </section>

      {/* Features */}
      <section className="container-fluid text-center my-5" id="how_it_works" dir={isRTL ? 'rtl' : 'ltr'}>
        <div className="features-heading" data-aos="fade-up">
          <h1 data-aos="fade-up" data-aos-delay="200">
            How It Works
          </h1>
          <img
            src={bannerBrush}
            alt=""
            className="company-brush feature-brush"
            data-aos="zoom-in"
            data-aos-delay="400"
          />
          <p
            className="mt-5 company-para"
            data-aos="fade-up"
            data-aos-delay="600"
          >
            Simple steps to get the service you need
          </p>
        </div>

        <Container className="my-5">
          <Row className="g-4 justify-content-center">
            {features.map((item, index) => (
              <Col key={index} md={3} sm={6}>
                <div
                  className={`feature-card ${item.gradient} d-flex justify-content-between align-items-end`}
                  data-aos="slide-up"
                  data-aos-delay={200 + index * 200}
                >
                  <div className="card-img">
                    <i className={`bi ${index === 0 ? 'bi-search' : index === 1 ? 'bi-calendar-check' : index === 2 ? 'bi-chat-dots' : 'bi-check-circle'}`}></i>
                  </div>
                  <div className="card-content">
                    <h5 className="text-white">{item.title}</h5>
                    <p className="text-white mb-0 text-start">{item.text}</p>
                  </div>
                </div>
              </Col>
            ))}
          </Row>
        </Container>
      </section>

      {/* Why Choose Us */}
      <section
        className="container-fluid text-center mb-5 top pt-5 services-section"
        id="why_choose_us"
        dir={isRTL ? 'rtl' : 'ltr'}
      >
        <div className="services-heading" data-aos="fade-up">
          <h1 data-aos="fade-up" data-aos-delay="200">
            <span className="services-txt text-dark">Why Choose Royal Spark?</span>
          </h1>
          <img
            src={bannerBrush}
            alt=""
            className="company-brush services-brush"
            data-aos="zoom-in"
            data-aos-delay="400"
          />
        </div>
        <div className="container py-5">
          <div className="row services-row row-cols-1 row-cols-sm-2 row-cols-md-3 row-cols-lg-4 g-4 ">
            <div
              className="col rounded-4 service1"
              data-aos="fade-up"
              data-aos-delay="200"
            >
              <div className="service-icon">
                <i className="bi bi-grid-3x3-gap-fill"></i>
              </div>
              <div>
                <h4>Multiple industries</h4>
                <p>
                  Access to multiple industries in one app
                </p>
              </div>
            </div>
            <div
              className="col rounded-4 service1"
              data-aos="fade-up"
              data-aos-delay="400"
            >
              <div className="service-icon">
                <i className="bi bi-shield-check"></i>
              </div>
              <div>
                <h4>Verified & Trusted</h4>
                <p>
                  Verified & trusted professionals
                </p>
              </div>
            </div>
            <div
              className="col rounded-4 service1"
              data-aos="fade-up"
              data-aos-delay="600"
            >
              <div className="service-icon">
                <i className="bi bi-credit-card-fill"></i>
              </div>
              <div>
                <h4>Booking & payments</h4>
                <p>
                  Seamless booking & payments
                </p>
              </div>
            </div>
            <div
              className="col rounded-4 service1"
              data-aos="fade-up"
              data-aos-delay="800"
            >
              <div className="service-icon">
                <i className="bi bi-star-fill"></i>
              </div>
              <div>
                <h4>Reviews & Ratings</h4>
                <p>
                  Transparent reviews & ratings
                </p>
              </div>
            </div>
            <div
              className="col rounded-4 service1"
              data-aos="fade-up"
              data-aos-delay="1000"
            >
              <div className="service-icon">
                <i className="bi bi-clock-fill"></i>
              </div>
              <div>
                <h4>On-Demand, anytime</h4>
                <p>
                  Available on-demand, anytime
                </p>
              </div>
            </div>
         
           
          </div>
        </div>
      </section>

  
      <Footer />
    </>
  );
};

export default HomePage;
